var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-forbidden"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.$t("error_forbidden"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }